import { Carousel, CarouselSkeleton } from 'client/components/Carousel';
import useConfigContext from 'client/context/config';
import React from 'react';
import { RenderType } from 'shared/consts/recommendations';

export default function Body() {
  const config = useConfigContext();
  if (
    config.noResponse ||
    config.renderType === RenderType.AddToBasket ||
    config.renderType === RenderType.InGrid ||
    config.renderType === RenderType.BannerInGrid ||
    config.renderType === RenderType.Banner
  ) {
    return null;
  }
  if (typeof window === 'undefined' || !config.rec)
    return <CarouselSkeleton data-testid="recommendations-carousel" />;
  return (
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    <Carousel
      title={config.rec.title}
      products={config.rec.productData!}
      data-testid="recommendations-carousel"
    />
  );
}
